export const AGENT_ONBOARDING_RUN_STATUSES = [
    'queued',
    'running',
    'completed',
    'failed',
    'cancelled',
];
export const AGENT_ONBOARDING_ACTIVE_STATUSES = [
    'queued',
    'running',
];
export const AGENT_ONBOARDING_TERMINAL_STATUSES = [
    'completed',
    'failed',
    'cancelled',
];
export const isAgentOnboardingRunTerminal = (status) => AGENT_ONBOARDING_TERMINAL_STATUSES.includes(status);
export const AGENT_ONBOARDING_STAGES = [
    'preparing_project',
    'exploring_warehouse',
    'deploying_semantic_layer',
    'building_dashboard',
    'verifying',
    'handoff',
];
//# sourceMappingURL=types.js.map